import React from 'react';
import PropTypes from 'prop-types';

import {Box, Stack, Typography} from 'views/components';
import {Translate} from 'views/module';

const ActionLog = (props) => {
  const {
    actionLog,
  } = props;
  const sortedActionLog = [...actionLog].sort((firstLog, secondLog) => {
    const firstCreatedAt = new Date(firstLog.createdAt).getTime();
    const secondCreatedAt = new Date(secondLog.createdAt).getTime();

    return firstCreatedAt - secondCreatedAt;
  });

  return (
    <Stack gap={1.5}>
      <Typography
        sx={{
          fontSize: '17px',
          fontWeight: 400,
          color: '#1A1916',
          textDecoration: 'underline',
          textDecorationColor: '#DA7955',
          textUnderlineOffset: '5px',
        }}
      >
        <Translate expression='case.Detail.ActionLog.Title' />
      </Typography>
      <Box
        sx={{
          backgroundColor: '#FFFFFF',
          border: '1px solid #E8E4DE',
          borderRadius: '12px',
          overflow: 'hidden',
        }}
      >
        {
          sortedActionLog.length === 0 && (
            <Typography
              sx={{
                px: 3,
                py: 2,
                fontSize: '12px',
                color: '#A8A49E',
              }}
            >
              <Translate expression='case.Detail.ActionLog.Empty' />
            </Typography>
          )
        }
        {
          sortedActionLog.map((actionLogEntry, index) => {
            const createdAtDate = new Date(actionLogEntry.createdAt);
            const createdAtLabel = Number.isNaN(createdAtDate.getTime()) ?
              '' :
              createdAtDate.toLocaleString([], {
                month: 'short',
                day: 'numeric',
                year: 'numeric',
                hour: 'numeric',
                minute: '2-digit',
              });

            return (
              <Stack
                key={`${actionLogEntry.createdAt}-${index}`}
                gap={1}
                sx={{
                  px: 3,
                  py: 2,
                  borderBottom: index === sortedActionLog.length - 1 ? 'none' : '1px solid #E8E4DE',
                }}
              >
                <Typography
                  sx={{
                    fontSize: '12px',
                    fontWeight: 500,
                    color: '#A8A49E',
                  }}
                >
                  {createdAtLabel}
                </Typography>
                <Typography
                  sx={{
                    fontSize: '14px',
                    fontWeight: 400,
                    color: '#1A1916',
                    lineHeight: '20px',
                    whiteSpace: 'pre-wrap',
                    wordBreak: 'break-word',
                  }}
                >
                  {actionLogEntry.message}
                </Typography>
              </Stack>
            );
          })
        }
      </Box>
    </Stack>
  );
};

ActionLog.propTypes = {
  actionLog: PropTypes.array.isRequired,
};

export default React.memo(ActionLog);
